import React, { useContext, useState, useEffect } from 'react'
import { GlobalState } from '../../GlobalState'
import {Grid, List} from 'react-feather'
import { Switch } from 'antd';
import {FormGroup, Input, Label} from 'reactstrap'

function Filter() {

    const state = useContext(GlobalState)
    const [showMethod, setShowMethod] = state.showMethod
    const [stakedOnly, setStakedOnly] = state.stakedOnly
    const [dataToShow, setDataToShow] = state.dataToShow
    const [sortBy, setSortBy] = state.sortBy
    const [search, setSearch] = state.search
    const [tableIconColor, setTableIconColor] = useState("#56ced7") // default selected
    const [cardIconColor, setCardIconColor] = useState("#b6f2fa") // default not selected
    const [stakedSwitchColor, setStakedSwitchColor] = useState("#ffe4b8") // default false

    const onChange = (e) => {
        setStakedOnly(e)
        if(e === true){
            setStakedSwitchColor("#fcb034") // darken yellow if true
        } else {
            setStakedSwitchColor("#ffe4b8") // muted yellow if false 
        }
    }

    // if Table view selected
    const handleTableIconClick = () => {
        setShowMethod("table")
        setTableIconColor("#56ced7")
        setCardIconColor("#b6f2fa")
    }

    // if card view selected
    const handleCardIconClick = () => {
        setShowMethod("card")
        setTableIconColor("#b6f2fa")
        setCardIconColor("#56ced7")
    }

    // show whether live data or finished data
    const handleDataToShow = (e) => {
        if(e === true){
            setDataToShow("live")
        } else {
            setDataToShow("finished")
        }
    }


    return (
        <div className="d-flex justify-content-center">
        <div className="container row mt-5 mb-3">

            
            <div className="col-md-8 col-sm-12 d-flex justify-content-start mt-4">
                <Grid color={cardIconColor} onClick={handleCardIconClick} />
                <List color={tableIconColor} size={32} style={{ marginLeft: '10px', marginTop: '-4px'}} onClick={handleTableIconClick} />
                
                <Switch onChange={onChange} style={{marginLeft: '40px', backgroundColor: stakedSwitchColor}} />
                <p className="blue_text">Staked Only</p>

                <Switch checkedChildren="Live" unCheckedChildren="Finished" style={{marginLeft: '40px', backgroundColor: "#fcb034", overflow: 'hidden', fontWeight: '700'}} className="col-md-2 col-sm-4" onClick={handleDataToShow} />
            
            </div>

            <div className="col-md-2 col-sm-12 justify-content-center">
                <Label className="form-label blue_text" htmlFor="sort-by">
                    Sort By
                </Label> 
                <br />
                <FormGroup>
                    <Input color='primary' className="yellow_background" value={sortBy} type='select' name='select' id='sort-by' onChange={e => setSortBy(e.target.value)}>
                        <option value=''>Active</option>
                        <option value='pending'>Pending</option>
                        <option value='close'>Closed</option>
                        <option value='on_hold'>On Hold</option>
                        <option value='reject'>Rejected</option>
                    </Input>
                </FormGroup>
            </div>

            <div className="col-md-2 col-sm-12 justify-content-center">
                <Label className="blue_text" htmlFor="search-input">
                    Search
                </Label> 
                <br />
                <Input color='primary' className="yellow_background" value={search} id='search-input' onChange={e => setSearch(e.target.value)} />
                
            </div>
            
        </div>
        </div>
    )
}

export default Filter
